{
  "title": "Trash",
  "typeLabel": "Type",
  "restore": "Restore",
  "columns": {
    "number": "Number",
    "date": "Date",
    "branch": "Branch",
    "employee": "Employee",
    "amount": "Amount",
    "deletedAt": "Deleted at",
    "deletedBy": "Deleted by",
    "employeePhone": "Employee phone",
    "customer": "Customer",
    "product": "Type",
    "barrelPrice": "Barrel price",
    "jerrycanPrice": "Jerrycan price"
  },
  "types": {
    "REVOLVING_BALANCE": "Carried balances",
    "SALE": "Sales",
    "PURCHASE": "Purchases",
    "DEBT_MOVEMENT": "Debt sales",
    "PAYMENT": "Payments",
    "RECEIPT": "Receipts",
    "DEBTOR": "Debtors"
  },
  "confirmRestore": {
    "title": "Restore the record?",
    "description": "Record number {{number}} will be restored.",
    "descriptionDebtMovement": "Record number {{number}} will be restored and its effect re-applied to the debtor's balance."
  },
  "toasts": {
    "restored": "Record restored successfully",
    "deleted": "Record deleted permanently"
  },
  "empty": {
    "noResults": "No results",
    "noData": "No deleted records of this type"
  },
  "products": {
    "DIESEL": "Diesel",
    "PETROL": "Petrol"
  },
  "deletePermanently": "Delete permanently",
  "confirmDelete": {
    "title": "Delete the record permanently?",
    "description": "{{type}} record {{number}} will be deleted permanently and cannot be restored."
  }
}
